/**
 * Created by Marcus Zhao on 08/4/2020.
 * Description:
 * ------ maintenance history ------
 */

import { Injectable } from '@angular/core';
import { Subject, ReplaySubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class IntralinksUIService {
    setData$: Subject<any> = new ReplaySubject<any>(1);
}
